import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\">\n  <path d=\"M9.99996 13.1249C9.84163 13.1249 9.6833 13.0665 9.5583 12.9415L4.55829 7.94154C4.31663 7.69987 4.31663 7.29987 4.55829 7.0582C4.79996 6.81654 5.19996 6.81654 5.44163 7.0582L9.99996 11.6165L14.5583 7.0582C14.8 6.81654 15.2 6.81654 15.4416 7.0582C15.6833 7.29987 15.6833 7.69987 15.4416 7.94154L10.4416 12.9415C10.3166 13.0665 10.1583 13.1249 9.99996 13.1249Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol